import { CSSProperties, FC } from 'react';
import classNames from 'classnames/bind';
import { allowedTagVariants, TypographyProps } from '../types/propType';
import styles from './Typography.module.scss';

const cx = classNames.bind(styles);

const Typography: FC<TypographyProps> = ({ as = 'h2', children, align, color, theme }) => {
  // Check if the provided "as" prop is valid; if not, default to "h2"
  const Tag = allowedTagVariants[as] || 'h2';
  // Inline style object
  const style: CSSProperties = {
    textAlign: align ? align : 'center',
    color: color || undefined,
  };

  const fontClass = `typ-${Tag}` || '';

  const CClassname = cx('typography-root', [fontClass, theme]);

  return (
    <Tag style={style} className={CClassname}>
      {children}
    </Tag>
  );
};

export default Typography;
